import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import configureStore, { history } from './appRedux/store';
import './assets/vendors/style';
// import "./firebase/firebase";
import App from './containers/App/index';
import { useAuth } from './contexts/AuthContext';
// import { registerFirebaseServiceWorker } from "./register-sw";
// import registerServiceWorker from "./_registerServiceWorker";
import {
  askForPermissioToReceiveNotifications,
  initializeFirebase,
} from './push-notification';
import './styles/wieldy.less';

/* provide initial state if any */
const store = configureStore({});
const NextApp: React.FC = () => {
  const auth = useAuth();

  useEffect(() => {
    // registerFirebaseServiceWorker();
    // registerServiceWorker();
    initializeFirebase();
  }, []);

  useEffect(() => {
    if (auth.userEmployeePosition.personCode) {
      askForPermissioToReceiveNotifications();
    }
  }, [auth.userEmployeePosition.personCode]);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Router basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </Router>
      </ConnectedRouter>
    </Provider>
  );
};

export default NextApp;
